import React, { useState, useEffect } from 'react';
import api from "../../../../../api";

const RepositorySection = () => {
  const [repo, setRepo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRepositoryData = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/library");

        const repository =
          response.data.groups.find(group => group.repository_section)
            ?.repository_section;

        setRepo(repository);
      } catch (error) {
        console.error("Repository API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRepositoryData();
  }, []);

  if (loading) return null;
  if (!repo || !repo.logos || repo.logos.length === 0) return null;

  return (
    <section id="repository">
      <div className="container overflow-hidden">

        <div
          className="marquee-wrapper"
          onMouseEnter={(e) =>
            (e.currentTarget.querySelector(".marquee-content").style.animationPlayState = "paused")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.querySelector(".marquee-content").style.animationPlayState = "running")
          }
        >
          <div className="marquee-content">

            {/* FIRST SET */}
            {repo.logos.map((logo, index) => (
              <div key={index} className="item">
                <img
                  src={`${process.env.REACT_APP_API_URL}${logo}`}
                  className="img-fluid mb-3 logo"
                  alt="Repository Logo"
                />
              </div>
            ))}

            {/* DUPLICATE FOR INFINITE LOOP */}
            {repo.logos.map((logo, index) => (
              <div key={`dup-${index}`} className="item">
                <img
                  src={`${process.env.REACT_APP_API_URL}${logo}`}
                  className="img-fluid mb-3 logo"
                  alt="Repository Logo"
                />
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default RepositorySection;
